import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as communiqueActions from '../../actions/communiques';

function mapStateToProps(state) {
    return {
        communiques : state.communiques
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(communiqueActions, dispatch);
}

class Communiques extends React.Component {

    render() {
        return React.cloneElement(this.props.children, this.props);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Communiques);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Communiques.jsx
 **/